import React, { useEffect, useState, useRef } from 'react';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import SliderBar from './SliderBar';
import CopilotFilter from './CopilotFilter';
import CopilotClassify from './CopilotClassify';
import CopilotSearch from './CopilotSearch';
import CopilotVision from './CopilotVision';

import { useSessionContext } from '../../contexts/SessionContext';
import { useCopilotContext } from '../../contexts/CopilotContext';
import { useCopilotStyles } from './styles';

import { AI_MODES, AI_MODES_IDX } from '../../global/constants/general';

const { VISION, CLASSIFY, FILTER, SEARCH } = AI_MODES_IDX;

const Copilot = ({
  viewTitle,
  copilotHeight: height,
  setCopilotHeight: setHeight,
}: {
  viewTitle: string;
  copilotHeight: number;
  setCopilotHeight: (value: number) => void;
}) => {
  const styles = useCopilotStyles();
  const { selectedImage } = useSessionContext();
  const {
    setAiMode,

    clearSearchResults,
    searchLoading,
    searchError,

    setSelectedSentenceId,
  } = useCopilotContext();

  useEffect(() => {
    if (selectedImage) setAIModeIndex(0);
  }, [selectedImage]);

  const [aiModeIndex, setAIModeIndex] = useState<number>(2);
  const handleAIModeChange = (event: React.SyntheticEvent, mode: number) => {
    setSelectedSentenceId('');
    clearSearchResults();

    setAiMode(AI_MODES[mode]);
    setAIModeIndex(mode);
  };

  const a11yProps = (index: number) => {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  };

  return (
    <>
      <Box height={`${height}%`} marginBottom={'-1rem'}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid #ccc',
            padding: '0 1rem',
          }}>
          <Typography
            sx={{
              ...styles.viewTitle,
              borderBottom: 0,
              backgroundColor: 'transparent',
            }}>
            {viewTitle}
          </Typography>
          <Tabs value={aiModeIndex} onChange={handleAIModeChange}>
            {AI_MODES.map((mode, index) => (
              <Tab
                key={index}
                sx={{ paddingBottom: '0' }}
                label={mode}
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
        </Box>
        <Box sx={{ ...styles.bottomPanel, padding: '1rem', paddingTop: '0' }}>
          {searchLoading
            ? 'loading...'
            : searchError
              ? 'Errors !'
              : (aiModeIndex === VISION && <CopilotVision />) ||
                (aiModeIndex === SEARCH && <CopilotSearch />) ||
                (aiModeIndex === FILTER && <CopilotFilter />) ||
                (aiModeIndex === CLASSIFY && <CopilotClassify />)}
        </Box>
      </Box>
      <SliderBar
        sx={{ transform: 'translateY(-55px)' }}
        setHeight={setHeight}
      />
    </>
  );
};

export default Copilot;
